import { clsx } from 'clsx'
import { type FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { LoadingButton } from 'base-ui'

import { type ContactFormState } from '../../../../contact-form'
import { type OpenableControls } from '../../../../generic-hooks'
import { Loading } from '../../../../loading'
import {
  refetchUseApiOrdersSwrGetOrders,
  useApiOrdersSwrGetOrders,
} from '../../../../order'
import { useDirectContactFormOrders } from '../../../hooks/useDirectContactFormOrders'

import { DirectContactFormOrderProductsSelectionCard } from './DirectContactFormOrderProductsSelectionCard'

const MAX_VISIBLE_ITEMS = 6

export const DirectContactFormOrderProductsSelection: FC<{
  formState: ContactFormState
  modalControls: OpenableControls
}> = ({ formState, modalControls }) => {
  const [page, setPage] = useState(0)
  const { data, isLoading } = useApiOrdersSwrGetOrders({
    itemsPerPage: 6,
    page,
  })

  const orders = useDirectContactFormOrders({ data })

  if (orders.length === 0) {
    return null
  }

  if (orders.length === 0 && data?.orders?.length === 0) {
    modalControls.handleClose()
  }

  return (
    <>
      {isLoading && data?.orders && data.orders.length === 0 ? (
        <Loading />
      ) : (
        <div
          className={clsx(
            'grid gap-4',
            orders.length === 1 ? 'tablet:grid-cols-1' : 'tablet:grid-cols-2',
          )}
        >
          {orders.length > 0
            ? orders.map((order) => {
                return (
                  <DirectContactFormOrderProductsSelectionCard
                    formState={formState}
                    key={order.orderMasterData?.orderNumber}
                    modalControls={modalControls}
                    order={order}
                  />
                )
              })
            : null}
        </div>
      )}
      {data?.totalItems && data.totalItems > MAX_VISIBLE_ITEMS ? (
        <div className="mt-10 flex w-full justify-center">
          <LoadingButton
            className="mb-2 w-full tablet:w-1/2"
            data-qa-id="contact-form-load-more-products-button"
            loading={isLoading}
            onClick={() => {
              setPage((prevState) => {
                return prevState + 1
              })
              void refetchUseApiOrdersSwrGetOrders(page)
            }}
            variant="outlined"
          >
            <FormattedMessage id="direct.contact.form.load.more.orders" />
          </LoadingButton>
        </div>
      ) : null}
    </>
  )
}
